'use strict';

angular.module('2FaAuth')

.service('twoFaSetup', function ($uibModal) {

    this.modalInstance = null;

    this.close = () => {
        if (this.modalInstance) {
            this.modalInstance.close();
            this.modalInstance = null;
        }
    };

    this.showModal = () => {

        this.close();

        this.modalInstance = $uibModal.open({
            templateUrl: '2fa-auth/2FaAuthCtrl.html',
            controller: '2FaAuthCtrl',
            controllerAs: '$ctrl',
            bindToController: true,
            backdrop: true,
        });
    };
});
